module.exports = __webpack_public_path__ + "static/media/ic_boywin.b84d3716.png";